// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1h0bs";
var _4 = "root_checked-2kl8_";
var _5 = "root_disabled-2B2hO";
var _6 = "label-2Pllu";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "root_checked", _5 as "root_disabled", _6 as "label" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "root_checked": _4, "root_disabled": _5, "label": _6 }
